export default "__VITE_ASSET__B2tCbqs0__"